import React, { useEffect, useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { showErrorToast } from 'components/Toast';
import { cleanObject } from 'utils/functions';
import GeneralApi from 'utils/generalApi';
import { IUser } from 'utils/interfaces';
import { useAuth } from 'contexts/Auth';

export default function CompanyModalContent({
  title,
  actionData,
  onClose,
  onSuccess,
}: {
  title: string;
  actionData?: IUser;
  onClose: () => void;
  onSuccess: () => void;
}) {
  const {
    //watch,
    setValue,
    //handleSubmit,
    //formState: { errors },
  } = useForm<any>({
    defaultValues: actionData
      ? {
        ...actionData,
        ...(actionData.company.license || {}),
        date: actionData.company.license?.date
          ? new Date(actionData.company.license?.date).toISOString().split('T')[0]
          : '',
        ruc: actionData.company.ruc || '',
        workers_amount: actionData.company.workers_amount || '',
        bussiness_name: actionData.company.bussiness_name || '',
        address: actionData.company.address || '',
      }
      : {},
  });
  const history = useNavigate();
  const auth = useAuth();

  const [tokens, setTokens] = useState([]);
  const [companies, setCompanies] = useState([]);

  const generalApi = useMemo(() => new GeneralApi(auth, history), [auth, history]);

  const handleCheckboxChange = async (data: any, action: string) => {

    var resquest = {
      "action": action,
      "auth_token": "",
      "api_key": "",
      "name": "",
      "company_id": 0,
      "userId": actionData?._id,
      "email": actionData?.email,
      "organizationId": actionData?.company.organization,
      "companyId": data._id,
      "ruc": data.ruc,
      "secretSeed": ""
    }
    // setLoading(true);
    await generalApi.post('/organization/bukauthtokens', {
      ...cleanObject(resquest)
    })

    fetchbukauthtokens();

  };


  const fetchbukauthtokens = async () => {
    try {
      const result: any = await generalApi.get('/organization/bukauthtokens?email=' + actionData?.email);
      if (!result.success) return showErrorToast(result.message);
      setTokens(result.data);

    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {

    fetchbukauthtokens();
  }, []); // Solo se ejecuta una vez al montar el componente

  useEffect(() => {
    const getLicense = async () => {
      let result: any = await generalApi.get('/licenses');
      if (!result.success) return showErrorToast(result.message);
      setValue('unit_cost', result.data.license.cost);
      setValue('max_records', 100);
      setValue(
        'date',
        new Date(new Date().setFullYear(new Date().getFullYear() + 1)).toISOString().split('T')[0]
      );
    };
    if (!actionData?.company?.license?.cost) getLicense();
  }, [generalApi, setValue, actionData]);




  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const result: any = await generalApi.get('/organization/companies?organizationId=' + actionData?.company.organization);
        if (!result.success) return showErrorToast(result.message);
        setCompanies(result.data);

      } catch (err) {
        console.error(err);
      }
    };

    fetchUsers();
  }, []); // Solo se ejecuta una vez al montar el componente

  return (
    <form>
      <div className="rounded-t-lg bg-primary-base px-4 pb-4 sm:flex sm:items-start sm:p-6 sm:py-4">
        <div className="pt-3 text-center sm:pt-0 sm:text-left">
          <h3 className="text-lg font-medium leading-6 text-white" id="modal-headline">
            {title || 'Confirmar acción'}
          </h3>
        </div>
      </div>
      <div className="">
        <div className="space-y-4 px-4 py-5">

          <ul className="space-y-3 max-h-96 overflow-y-auto">
            {companies.map((company: any) => (
              <li
                key={company._id}
                className="flex items-center justify-between border p-3 rounded hover:bg-gray-50"
              >
                <div className="flex items-center space-x-3">
                  <input
                    type="checkbox"
                    className="w-5 h-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
                    // checked={selected.includes(company._id)}
                    checked={tokens.some((token: any) => token.companyId === company._id)}
                    //  onChange={() => handleCheckboxChange(company)}
                    onChange={() =>
                      tokens.some((token: any) => token.companyId === company._id)
                        ? handleCheckboxChange(company, 'D')
                        : handleCheckboxChange(company, 'I')
                    }
                  />
                  <div>
                    <p className="font-medium text-gray-900">{company.bussiness_name}</p>
                    <p className="text-sm text-gray-500">RUC: {company.ruc}</p>
                  </div>
                </div>
              </li>
            ))}
          </ul>

        </div>
        <br></br>
      </div>
    </form>
  );
}
